import React, { useState } from "react";
import Button from "../UI/Button";
import { tx } from "../../lib/ddd/ddd";
import Steps from "./Steps";
import Docs from "./Docs";

const SaveInvoiceOptions = ({ onPassData }) => {
  const [steps, setSteps] = useState([]);
  const [docs, setDocs] = useState([]);

  const onUpdateStepsHandler = (newSteps) => {
    setSteps(newSteps);
  };

  const onUpdateDocsHandler = (newDocs) => {
    setDocs(newDocs);
  };

  const onSaveInvoiceHandler = () => {
    onPassData(steps, docs);
  };

  return (
    <>
      <Steps onPassSteps={onUpdateStepsHandler} />
      <Docs onPassDocs={onUpdateDocsHandler} />
      <Button className="w-100 mt-2 py-1" onClick={onSaveInvoiceHandler}>
        {tx("DDDI_Save")}
      </Button>
    </>
  );
};

export default SaveInvoiceOptions;
